


































import { Component, Vue, Watch } from 'vue-property-decorator'
import LoginCortesias from '@/components/LoginCortesias.vue'
import CortesiasPanel from '@/components/CortesiasPanel.vue'

@Component({
  components: {
    LoginCortesias,
    CortesiasPanel
  }
})
export default class ViewCortesias extends Vue {
  private name: string = 'ViewCortesias'
  private info: any = null

  @Watch('info')
  private watchInfo (v: any) {
    console.log('watchInfo :: ', v)
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
  }
}
